// This file is auto-generated by @hey-api/openapi-ts
import type { CancelablePromise } from "./core/CancelablePromise";
import { OpenAPI } from "./core/OpenAPI";
import { request as __request } from "./core/request";
import type {
  GetApiDownloadsDownloadDataSheetData,
  GetApiDownloadsDownloadDataSheetResponse,
  GetApiEasyAdministrationAreaCountryListResponse,
  GetApiEasyAdministrationAreaResponse,
  GetApiEasyCheckLoginStateResponse,
  GetApiEasyCountryResponse,
  GetApiHealthDatabaseCleanupWithCpqResponse,
  GetApiLineItemApiLineItemPropertiesData,
  GetApiLineItemApiLineItemPropertiesResponse,
  GetApiQuoteApiConvertSessionFromEasyByIdData,
  GetApiQuoteApiConvertSessionFromEasyByIdResponse,
  GetApiQuoteApiGetQuoteIdResponse,
  GetApiQuoteApiLanguageResponse,
  GetApiTestEasyTokenResponse,
  GetApiTestGetMockSessionResponse,
  GetApiTestJumpToEasyResponse,
  GetApiTestJwTtoken2Response,
  GetApiTestJwTtokenResponse,
  GetApiTestNameResponse,
  GetApiTestResponse,
  GetPreviewApi3PqCpqV1QuotesByIdData,
  GetPreviewApi3PqCpqV1QuotesByIdResponse,
  GetPreviewApi3PqCpqV1QuotesResponse,
  GetPreviewApi3PqCpqV1StatusByIdData,
  GetPreviewApi3PqCpqV1StatusByIdResponse,
  PostApiAskForQuotationAskForQuotationEmailData,
  PostApiAskForQuotationAskForQuotationEmailResponse,
  PostApiAskForQuotationSendAskForQuotationEmailData,
  PostApiAskForQuotationSendAskForQuotationEmailResponse,
  PostApiEasyRedirectToEasyData,
  PostApiEasyRedirectToEasyResponse,
  PostApiEasySessionFromEasyData,
  PostApiEasySessionFromEasyResponse,
  PostApiEasySessionFromWegWebsiteData,
  PostApiEasySessionFromWegWebsiteResponse,
  PostApiHealthKeepaliveData,
  PostApiHealthKeepaliveResponse,
  PostApiImportImportLineitemData,
  PostApiImportImportLineitemResponse,
  PostApiNeedHelpNeedHelpData,
  PostApiNeedHelpNeedHelpResponse,
  PostApiTestConvertToSingleUseTokenData,
  PostApiTestConvertToSingleUseTokenResponse,
  PostApiTestMockEasySynchronizationData,
  PostApiTestMockEasySynchronizationResponse,
  PostApiTestTestData,
  PostApiTestTestEmailData,
  PostApiTestTestEmailResponse,
  PostApiTestTestResponse,
  PostApiTestWegTestCallData,
  PostApiTestWegTestCallResponse,
  PostPreviewApi3PqCpqV1QuotesData,
  PostPreviewApi3PqCpqV1QuotesResponse,
  PutApiEasyAdministrationAreaData,
  PutApiEasyAdministrationAreaResponse,
  PutApiLineItemApiLineItemPropertiesData,
  PutApiLineItemApiLineItemPropertiesResponse,
  PutApiQuoteApiLanguageData,
  PutApiQuoteApiLanguageResponse,
} from "./types.gen";

export class AskForQuotationService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMWegStoreFinder OK
   * @throws ApiError
   */
  public static postApiAskForQuotationAskForQuotationEmail(
    data: PostApiAskForQuotationAskForQuotationEmailData = {},
  ): CancelablePromise<PostApiAskForQuotationAskForQuotationEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/AskForQuotation/AskForQuotationEmail",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        500: "Internal Server Error",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown OK
   * @throws ApiError
   */
  public static postApiAskForQuotationSendAskForQuotationEmail(
    data: PostApiAskForQuotationSendAskForQuotationEmailData = {},
  ): CancelablePromise<PostApiAskForQuotationSendAskForQuotationEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/AskForQuotation/SendAskForQuotationEmail",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }
}

export class DownloadsService {
  /**
   * @param data The data for the request.
   * @param data.materialNumber
   * @param data.country
   * @param data.language
   * @returns unknown OK
   * @throws ApiError
   */
  public static getApiDownloadsDownloadDataSheet(
    data: GetApiDownloadsDownloadDataSheetData = {},
  ): CancelablePromise<GetApiDownloadsDownloadDataSheetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/Downloads/DownloadDataSheet",
      query: {
        materialNumber: data.materialNumber,
        country: data.country,
        language: data.language,
      },
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        409: "Conflict",
      },
    });
  }
}

export class EasyService {
  /**
   * @returns ReturnedString OK
   * @throws ApiError
   */
  public static getApiEasyCheckLoginState(): CancelablePromise<GetApiEasyCheckLoginStateResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/Easy/CheckLoginState",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns VMEasySynchronizationResponse OK
   * @throws ApiError
   */
  public static postApiEasyRedirectToEasy(
    data: PostApiEasyRedirectToEasyData = {},
  ): CancelablePromise<PostApiEasyRedirectToEasyResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/Easy/RedirectToEasy",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
        409: "Conflict",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown OK
   * @throws ApiError
   */
  public static postApiEasySessionFromEasy(
    data: PostApiEasySessionFromEasyData = {},
  ): CancelablePromise<PostApiEasySessionFromEasyResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/Easy/SessionFromEasy",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown OK
   * @throws ApiError
   */
  public static postApiEasySessionFromWegWebsite(
    data: PostApiEasySessionFromWegWebsiteData = {},
  ): CancelablePromise<PostApiEasySessionFromWegWebsiteResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/Easy/SessionFromWegWebsite",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }

  /**
   * @returns ReturnedString OK
   * @throws ApiError
   */
  public static getApiEasyAdministrationArea(): CancelablePromise<GetApiEasyAdministrationAreaResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/Easy/AdministrationArea",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns ReturnedString OK
   * @throws ApiError
   */
  public static putApiEasyAdministrationArea(
    data: PutApiEasyAdministrationAreaData = {},
  ): CancelablePromise<PutApiEasyAdministrationAreaResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/Easy/AdministrationArea",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }

  /**
   * @returns VMWegStoreFinder OK
   * @throws ApiError
   */
  public static getApiEasyAdministrationAreaCountryList(): CancelablePromise<GetApiEasyAdministrationAreaCountryListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/Easy/AdministrationAreaCountryList",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }

  /**
   * @returns VMWegStoreFinder OK
   * @throws ApiError
   */
  public static getApiEasyCountry(): CancelablePromise<GetApiEasyCountryResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/Easy/Country",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }
}

export class HealthService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown OK
   * @throws ApiError
   */
  public static postApiHealthKeepalive(
    data: PostApiHealthKeepaliveData = {},
  ): CancelablePromise<PostApiHealthKeepaliveResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/Health/keepalive",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns unknown OK
   * @throws ApiError
   */
  public static getApiHealthDatabaseCleanupWithCpq(): CancelablePromise<GetApiHealthDatabaseCleanupWithCpqResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/Health/DatabaseCleanupWithCpq",
    });
  }
}

export class ImportService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns ReturnedString OK
   * @throws ApiError
   */
  public static postApiImportImportLineitem(
    data: PostApiImportImportLineitemData = {},
  ): CancelablePromise<PostApiImportImportLineitemResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/Import/ImportLineitem",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }
}

export class LineItemApiService {
  /**
   * @param data The data for the request.
   * @param data.lineItemId
   * @returns VMLineItemInformation OK
   * @throws ApiError
   */
  public static getApiLineItemApiLineItemProperties(
    data: GetApiLineItemApiLineItemPropertiesData = {},
  ): CancelablePromise<GetApiLineItemApiLineItemPropertiesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/LineItemApi/LineItemProperties",
      query: {
        lineItemId: data.lineItemId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.lineItemId
   * @param data.requestBody
   * @returns VMLineItemInformation OK
   * @throws ApiError
   */
  public static putApiLineItemApiLineItemProperties(
    data: PutApiLineItemApiLineItemPropertiesData = {},
  ): CancelablePromise<PutApiLineItemApiLineItemPropertiesResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/LineItemApi/LineItemProperties",
      query: {
        lineItemId: data.lineItemId,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class NeedHelpService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown OK
   * @throws ApiError
   */
  public static postApiNeedHelpNeedHelp(
    data: PostApiNeedHelpNeedHelpData = {},
  ): CancelablePromise<PostApiNeedHelpNeedHelpResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/NeedHelp/NeedHelp",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }
}

export class QuoteApiService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown OK
   * @throws ApiError
   */
  public static postPreviewApi3PqCpqV1Quotes(
    data: PostPreviewApi3PqCpqV1QuotesData = {},
  ): CancelablePromise<PostPreviewApi3PqCpqV1QuotesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/preview/api/3pq-cpq/v1/quotes",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns unknown OK
   * @throws ApiError
   */
  public static getPreviewApi3PqCpqV1Quotes(): CancelablePromise<GetPreviewApi3PqCpqV1QuotesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/preview/api/3pq-cpq/v1/quotes",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown OK
   * @throws ApiError
   */
  public static getPreviewApi3PqCpqV1QuotesById(
    data: GetPreviewApi3PqCpqV1QuotesByIdData,
  ): CancelablePromise<GetPreviewApi3PqCpqV1QuotesByIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/preview/api/3pq-cpq/v1/quotes/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @returns string OK
   * @throws ApiError
   */
  public static getApiQuoteApiGetQuoteId(): CancelablePromise<GetApiQuoteApiGetQuoteIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/QuoteApi/GetQuoteId",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown OK
   * @throws ApiError
   */
  public static getApiQuoteApiConvertSessionFromEasyById(
    data: GetApiQuoteApiConvertSessionFromEasyByIdData,
  ): CancelablePromise<GetApiQuoteApiConvertSessionFromEasyByIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/QuoteApi/ConvertSessionFromEasy/{id}",
      path: {
        id: data.id,
      },
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }

  /**
   * @returns unknown OK
   * @throws ApiError
   */
  public static getApiQuoteApiLanguage(): CancelablePromise<GetApiQuoteApiLanguageResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/QuoteApi/Language",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown OK
   * @throws ApiError
   */
  public static putApiQuoteApiLanguage(
    data: PutApiQuoteApiLanguageData = {},
  ): CancelablePromise<PutApiQuoteApiLanguageResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/QuoteApi/Language",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }
}

export class StatusApiService {
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.start
   * @param data.size
   * @param data.sort
   * @param data.order
   * @param data.includes
   * @param data.filter
   * @returns unknown OK
   * @throws ApiError
   */
  public static getPreviewApi3PqCpqV1StatusById(
    data: GetPreviewApi3PqCpqV1StatusByIdData,
  ): CancelablePromise<GetPreviewApi3PqCpqV1StatusByIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/preview/api/3pq-cpq/v1/status/{id}",
      path: {
        id: data.id,
      },
      query: {
        start: data.start,
        size: data.size,
        sort: data.sort,
        order: data.order,
        includes: data.includes,
        filter: data.filter,
      },
    });
  }
}

export class TestService {
  /**
   * @returns unknown OK
   * @throws ApiError
   */
  public static getApiTest(): CancelablePromise<GetApiTestResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/Test",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }

  /**
   * @returns unknown OK
   * @throws ApiError
   */
  public static getApiTestJwTtoken(): CancelablePromise<GetApiTestJwTtokenResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/Test/JWTtoken",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }

  /**
   * @returns unknown OK
   * @throws ApiError
   */
  public static getApiTestJwTtoken2(): CancelablePromise<GetApiTestJwTtoken2Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/Test/JWTtoken2",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }

  /**
   * @returns unknown OK
   * @throws ApiError
   */
  public static getApiTestName(): CancelablePromise<GetApiTestNameResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/Test/name",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }

  /**
   * @returns unknown OK
   * @throws ApiError
   */
  public static getApiTestEasyToken(): CancelablePromise<GetApiTestEasyTokenResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/Test/EasyToken",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown OK
   * @throws ApiError
   */
  public static postApiTestConvertToSingleUseToken(
    data: PostApiTestConvertToSingleUseTokenData = {},
  ): CancelablePromise<PostApiTestConvertToSingleUseTokenResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/Test/ConvertToSingleUseToken",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }

  /**
   * @returns VMEasyRedirect OK
   * @throws ApiError
   */
  public static getApiTestJumpToEasy(): CancelablePromise<GetApiTestJumpToEasyResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/Test/JumpToEasy",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown OK
   * @throws ApiError
   */
  public static postApiTestWegTestCall(
    data: PostApiTestWegTestCallData = {},
  ): CancelablePromise<PostApiTestWegTestCallResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/Test/WegTestCall",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }

  /**
   * @returns unknown OK
   * @throws ApiError
   */
  public static getApiTestGetMockSession(): CancelablePromise<GetApiTestGetMockSessionResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/Test/GetMockSession",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown OK
   * @throws ApiError
   */
  public static postApiTestMockEasySynchronization(
    data: PostApiTestMockEasySynchronizationData = {},
  ): CancelablePromise<PostApiTestMockEasySynchronizationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/Test/MockEasySynchronization",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown OK
   * @throws ApiError
   */
  public static postApiTestTestEmail(
    data: PostApiTestTestEmailData = {},
  ): CancelablePromise<PostApiTestTestEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/Test/TestEmail",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown OK
   * @throws ApiError
   */
  public static postApiTestTest(
    data: PostApiTestTestData = {},
  ): CancelablePromise<PostApiTestTestResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/Test/Test",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad Request",
        401: "Unauthorized",
      },
    });
  }
}
